import  React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
// import 'popper.js/dist/popper.min.js';
import 'bootstrap/dist/js/bootstrap.js';
import './css/fontawesome/css/all.min.css';
import './css/animate/css/animate.min.css';
import './css/base.css';

import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex, changeValues, setInitialState } from "./redux/actions";
import { routesSelector } from "./redux/selectors";

import ErrorReload from './components/views/errors/error-reload';
import E401 from './components/views/errors/401';
import LoaderView from './components/views/loader';
import Login from './components/views/login';
import LoginComplete from './components/views/LoginComplete';
import Logout from './components/views/logout';
import {doLogout} from './components/views/logout';
import PageB2C from './components/views/PageB2C';
import PageDistinta from './components/views/PageDistinta';
import WishList from './components/views/WishList';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

import BaseClass from './components/common/baseClass';

import customConfig from "./components/common/customConfig";

const common = require('./components/common/common');
const cart = require('./components/common/cart');
const serviceWorker = require('./serviceWorker.js');
const env = require("./config.js").default;

window.$ = $;
window.cc = {};

class AppRouter extends BaseClass{
  constructor(props){
    super(props);

    this.state.render1 = false;
    this.state.render2 = false;
    this.state.render3 = false;
    this.state.error2 = false;
    this.state.error1 = false;
    this.state.loginNeeded = false;
    this.state.errorDistinta = false;
    this.marcheVM = [];
    this.openWishListFunction = this.openWishListFunction.bind(this);
    window.cc = new customConfig();
  }

  async componentWillMount(props) {
    $("body").append('<link rel="stylesheet" type="text/css" href="' + env.STATIC + "custom/css/variables_" + env.CSOFT + '.css">');
    $("body").append('<style>:root{--nav-container-background: url("' + env.STATIC + 'custom/background_900000-no-login.jpg") no-repeat center center/cover;}</style>');
    $("head").append('<link rel="icon" type="image/png" href="' + env.STATIC + 'custom/favicon_' + env.CSOFT + '.ico" />');
    
    //localStorage Params
    var appState = common.get_localStorage("appState");
    //URL Params
    let access_token = common.getParam("access_token");
    let checkout_url = common.getParam("checkout_url");
    let checkout_in_frame = common.getParam("checkout_in_frame");
    let cart_by_frame_message = common.getParam("cart_by_frame_message");
    common.remove_localStorage("checkout_in_frame");
    if(checkout_in_frame !== undefined && checkout_in_frame !== null && checkout_in_frame)
      common.set_localStorage("checkout_in_frame", true);
    common.remove_localStorage("cart_by_frame_message");
    if(cart_by_frame_message !== undefined && cart_by_frame_message !== null && cart_by_frame_message)
      common.set_localStorage("cart_by_frame_message", true);
    if(cart.isCartByFrameMessage()){
      $("body").append(`<style>
      .sw-wish-list{
          display: none!important;
      }
      .tooltip_cart{
          display: none!important;
      }
      </style>
      `);
    }
    
    if (env.BACKEND_LOGIN_CLIENT_ID === '' && env.BACKEND_LOGIN_CLIENT_SECRET === '' && access_token) {
      if (appState) {
        doLogout();
        this.props.setInitialState();
      }
      common.set_localStorage("appState", access_token);
      common.remove_localStorage("cart_id");
      common.verifyLogin().then(response => {
        if (!response) {
          common.remove_localStorage("appState");
          this.setState({ error2: true });
        }
      });
      if (checkout_url) {
        common.verifyUrl(checkout_url).then(response => {
          if (response.Valid === true) {
            common.set_localStorage("checkout_url", checkout_url);
          }
        })
      }
    }

    if(appState !== undefined && appState !== null && appState !== "" && appState ){
      this.setState({loginNeeded: false});
    }else{
      if(env.BACKEND_LOGIN_GRANT_TYPE !== 'client_credentials')
        this.setState({loginNeeded: true});
    }

    this.updateStateWithStoreProps();
    var newUrlPath = window.location.href;
    var renewMutex = this.state.renewMutex;
    var filtersState = {};
    var loginNeeded = false;

    if(env.BACKEND_LOGIN_GRANT_TYPE !== 'client_credentials'){
      common.verifyLogin().then(async response => {
        if(!response || response.error){
          loginNeeded = true;
          var appState = common.get_localStorage("appState");
          if(appState !== undefined && appState !== null && appState !== "" && appState )
            doLogout();
          this.setState({loginNeeded: true});
        }
      });
    }

    await window.cc.init().then(async response => {
      if (!loginNeeded)
        await window.cc.getUserInfo();
      common.setInitialLanguage();
      if(!this.state.renewMutex.newUrl){
        var marca = await common.getDefaultVM();
        if(marca !== undefined && marca !== null && marca !== false && Array.isArray(marca) && marca.length > 0){
          var filtersState = this.state.filtersState;
          filtersState.marca = marca[0]
          this.props.changeFilter("marca", marca[0]);
          this.setState({filtersState: filtersState, render1: true, error1: false/*, error2: false*/});
        }else
          this.setState({ error2: true, render1: true });
      }else
        this.setState({render1: true, error1: false});
    });

    this.marcheVM = await common.getAppEnabledVM();
    if (newUrlPath.search('draw/') > -1 && !this.state.error2) {
      newUrlPath = newUrlPath.substring(env.FRONTEND.length, window.location.href.length);
      newUrlPath = newUrlPath.split('?')[0];
      var splittedUrl = newUrlPath.split('/');
      renewMutex.newUrl = true;
      filtersState.marca = splittedUrl[1];
      filtersState.modello = splittedUrl[2];
      filtersState.tavola = splittedUrl[3];

      var isValidVM = await common.isValidVM(filtersState.marca);
      if(isValidVM){
        this.props.changeValues({filtersState: {marca: filtersState.marca, modello: filtersState.modello, tavola: filtersState.tavola}, renewMutex:{newUrl: true}});

        var detailDistinta = await common.apiCall(env.BACKEND + "epc/get_draw/", "GET", {zprod: filtersState.marca, cmoto: filtersState.modello, ctavo: filtersState.tavola}, true);
        if(detailDistinta.error === false){
          var cdima = filtersState.tavola;
          if (detailDistinta.CDIMA !== "")
            cdima = detailDistinta.CDIMA;

          this.props.changeValues({filtersState: {immagine: cdima, distintaGruppo: detailDistinta.DTTAV, distintaTavola: detailDistinta.DTAVO}});
          this.setState({render3: true});
        }else{
          this.setState({errorDistinta: true});
        }
      }else{
        this.setState({errorDistinta: true});
      }
    }

    await this.update();
    this.setState({render2: true});
  }

  async update(){
    await common.is_updateNeeded().then(function(result){
      if(result){
        serviceWorker.unregister();
        var version = common.get_localStorage("actualVersion");
        var updateCounter = common.get_localStorage("updateCounter");
        common.clear_localStorage();
        if(updateCounter !== null && updateCounter !== undefined)
          common.set_localStorage("updateCounter", updateCounter);
        sessionStorage.clear();
        common.set_localStorage("actualVersion", version);
        window.location.reload();
      }
    });
  }

  openWishListFunction(){
    var dataList = {};
    dataList.wishList = common.get_localStorage("wishList") ? JSON.parse(common.get_localStorage("wishList")) : [];
    this.props.changeDatalist("wishList", dataList.wishList);
  }

  componentWillReceiveProps(nextprops) {
    this.updateStateWithStoreProps(nextprops);
    if(this.state.renewMutex.newUrl && this.state.tavola !== "" && this.state.marca !== ""){
      this.setState({render3: true});
    }
    if(this.state.errorDistinta)
      this.setState({errorDistinta: false});

    var appState = common.get_localStorage("appState");

    if(appState !== undefined && appState !== null && appState !== "" && appState ){
      this.setState({loginNeeded: false});
    }else{
      if(env.BACKEND_LOGIN_GRANT_TYPE !== 'client_credentials')
        this.setState({loginNeeded: true});
    }
  }

  componentDidUpdate() {
    this.updateStateWithStoreProps();
    var appState = common.get_localStorage("appState");

    if(appState !== undefined && appState !== null && appState !== "" && appState ){
      this.state.loginNeeded =  false;
    } else if (env.BACKEND_LOGIN_GRANT_TYPE !== 'client_credentials'){
      this.state.loginNeeded = true;
    }
  }

  render(props){

    var myHeaderType = "header_centrato";
    if(this.state.render1)
      myHeaderType = window.cc.frontendCustomization.header; //header_sinistra, header_centrato, header_destra
    $("body").append('<style>:root{--nav-container-background: url("' + env.STATIC + 'custom/background_' + env.CSOFT + '-no-login.jpg") no-repeat center center/cover;}</style>');
    return(
      <>
      { (!this.state.render1 || !this.state.render2 || (this.state.renewMutex.newUrl && !this.state.render3) && !this.state.loginNeeded) ?
          <div id="wrap">
              <Router basename={env.BASEPATH}>
                <>
                  <Header headerType={myHeaderType} activeElements={[""]}></Header>
                  <div id="portal-columns">
                    <div className="row">
                      <div className="col-xl-12" id="content_page">
                        <h1 id="PartsFinderTitle" style={{textAlign: "center"}} className="mb-4 mt-2">{common.getTrad("Parts Finder")}</h1>
                        {
                          !this.state.error1 ?
                            <Routes>
                              <Route path="*" element={<LoaderView headerType={this.props.myHeaderType} />}/>
                            </Routes>
                          :
                            <Routes>
                              <Route path="*" element={<ErrorReload headerType={this.props.myHeaderType} />}/>
                            </Routes>
                        }
                      </div>
                    </div>
                  </div>
                  <Footer></Footer>
                </>
              </Router>
          </div>
          :
          this.state.loginNeeded ?
            <div id="wrap">
              <Router basename={env.BASEPATH}>
                <>
                  <Header headerType={myHeaderType} activeElements={["LanguageButton"]}></Header>
                    <div id="portal-columns" className="background_login">
                      <Routes>
                        <Route path="/logout" element={<Navigate to="/" />}/>
                        <Route path="/login-complete" element={<LoginComplete headerType={this.props.myHeaderType} />}/>
                        <Route path='*' element={<Login headerType={this.props.myHeaderType} />}/>
                      </Routes>
                    </div>
                  <Footer></Footer>
                </>
              </Router>
            </div>
          :
            <div id="wrap">
              <Router basename={env.BASEPATH}>
              {!this.state.error2 ?
                <>
                  <Header headerType={myHeaderType} activeElements={["UserButton","LanguageButton", "WishListButton"]} openWishListFunction={this.openWishListFunction}></Header>
                  <WishList headerType={myHeaderType} menuPaginaInterna={true}/>
                    <div id="portal-columns">
                      <div className="notifica_messaggio"></div>
                      <div className="row">
                        <div className="col-xl-12" id="content_page">
                          <h1 id="PartsFinderTitle" style={{textAlign: "center"}} className="mb-4 mt-2">
                            {this.state.filtersState.marca && this.marcheVM !== undefined && this.marcheVM.length > 1 ?
                              <>
                                <img alt={this.state.filtersState.marca} title={this.state.filtersState.marca} style={{maxHeight: "1.5em", verticalAlign: "middle"}} src={env.STATIC+ "loghi/" + this.state.filtersState.marca.toLowerCase() + ".png"} />
                                &nbsp;
                              </>
                            :
                              ""
                            }
                            {common.getTrad("Parts Finder")}
                          </h1>
                          <Routes>
                            <Route path="/" exact element={<PageB2C headerType={myHeaderType}  />} />
                            <Route path="/logout" exact element={() => {this.update(true); return(<Logout headerType={myHeaderType} />)}} />

                            <Route path="/login-complete" element={<Navigate to="/" />}/>
                            {!this.state.errorDistinta ?
                                <Route path="/draw/:zprod/:id_moto/:id_tavola" element={<PageDistinta headerType={myHeaderType} />}/>
                              :
                                <Route path="*" element={<Navigate to="/" />}/>
                            }
                          </Routes>
                        </div>
                      </div>
                    </div>
                    <Footer></Footer>
                </>
              :
                <>
                  <Header headerType={myHeaderType} activeElements={["LanguageButton"]}></Header>
                    <div id="portal-columns" className="background_login">
                      <Routes>
                        <Route path="*" element={<E401 headerType={this.props.myHeaderType} />}/>
                      </Routes>
                    </div>
                  <Footer></Footer>
                </>
              }
              </Router>
            </div>
      }
      </>
    )
  }
}


const mapStateToProps = state => {
  const store = routesSelector(state);
  return { store };
}
export default connect(mapStateToProps, { changeFilter, changeDatalist, changeMutex, changeValues, setInitialState })(AppRouter);
//export default AppRouter;
